import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountService {
  private url = environment.firebaseConfig.databaseURL;
  counts: string[] = [];
  countChange = new BehaviorSubject<number>(0);
  private count: string = '';
  constructor(private http: HttpClient) {}

  fetchCount() {
    this.http.get<string>(this.url + '/count.json').subscribe(
      (res) => {
        this.setCount(res);
        this.saveCount();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  saveCount() {
    this.counts[0] = '' + this.getCount();

    return this.http
      .put(this.url + '/count.json', this.counts)
      .subscribe((res) => {});
  }

  setCount(count: any) {
    this.count = count[0];
    this.countChange.next(parseInt(this.count) + 1);
  }
  getCount() {
    return parseInt(this.count) + 1;
  }
  UpdateCount() {
    this.counts[0] = '100';

    return this.http
      .put(this.url + '/count.json', this.counts)
      .subscribe((res) => {
        console.log(res);
      });
  }
}
